// src/components/HowItWorks.jsx
export default function HowItWorks() {
  const steps = [
    {
      num: 1,
      title: 'Je choisis mes produits',
      text: 'Ajoutez vos articles au panier ou envoyez la liste par WhatsApp.',
    },
    {
      num: 2,
      title: 'Je valide ma commande',
      text: 'Paiement Mobile Money via PayGate ou paiement à la livraison.',
    },
    {
      num: 3,
      title: 'Je reçois ma commande',
      text: 'Livraison rapide à domicile ou en point de retrait.',
    },
  ]

  return (
    <section className="mb-5">
      <div className="card-modern p-4">
        <h3 className="mb-3">Comment ça marche&nbsp;?</h3>
        <div className="row row-cols-1 row-cols-md-3 g-3">
          {steps.map((s) => (
            <div className="col" key={s.num}>
              <div className="h4 mb-1 text-primary">Étape {s.num}</div>
              <div className="fw-semibold mb-1">{s.title}</div>
              <div className="text-muted small">{s.text}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  )
}
